import PropTypes from 'prop-types';

import { HomeCheckerShape } from '../../../shapes/HomeChecker';
import CheckedIconPhoto from '../../ListingLabel/checkedInfo/ChekedIconPhoto';
import Feature from '../Feature';

import { IS_CHECKED_FEATURE } from '../featureList';
import CheckedDescription from '../../ListingLabel/checkedInfo/CheckedDescription';
import TitleChecked from '../../ListingLabel/checkedInfo/TitleChecked';

const CheckedFeature = ({
  homechecker = null,
  verificationDate = null,
  collapsed,
  onCollapsedChange,
  openModal
}) => {
  const renderBody = () => (
    <CheckedDescription
      homechecker={homechecker}
      verificationDate={verificationDate}
      onMoreDetailsClick={openModal}
      showButtonModal
    />
  );

  return (
    <Feature
      featureName={IS_CHECKED_FEATURE}
      collapsed={collapsed}
      onCollapsedChange={onCollapsedChange}
      renderBody={renderBody}
      renderHeader={styles => (
        <TitleChecked firstName={homechecker?.firstName} className={styles} />
      )}
      renderIcon={() => (
        <CheckedIconPhoto photoUrl={homechecker?.photoUrl} isVerified />
      )}
    />
  );
};

CheckedFeature.propTypes = {
  homechecker: PropTypes.shape(HomeCheckerShape),
  verificationDate: PropTypes.string,
  collapsed: PropTypes.bool.isRequired,
  onCollapsedChange: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired
};

export default CheckedFeature;
